module.exports = __webpack_public_path__ + "img/platform-icon-1.ad8abe07.png";